import React, {FC, memo, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {StompSessionProvider, useSubscription} from "react-stomp-hooks";
import SendingMessages from "../stomp/SendingMessages";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions as modal} from "../../store/sliceModal";
import {useDispatch, useSelector} from "react-redux";
import {config} from "../../config";
import {IUser} from "../../store/sliceUser";
import {Image, Spinner} from "react-bootstrap";
import {CloseButton, Microfone, VideoContainer, VideoImg} from "./Style";
import {AudioPlayer, AudioPlayerRef} from "react-audio-play";
import {MicFill, MicMute, MicMuteFill, VolumeMute, VolumeUp, XSquare, XSquareFill} from "react-bootstrap-icons";
import {actions as actionCamera, ICameraPayload} from "../../store/sliceCamera";

import SubscribeCamera from "../stomp/SubscribeCamera";
import {ICameraLive} from "../../store/sliceCamera";
import CameraImage from "./CameraImage";
import CameraAudio from "./CameraAudio";

type StompProps = {
    init?: () => void,
    name: string,
    onHide?: () => void,
    sound: boolean,
    isClose?: boolean,

   // children: React.ReactElement
}
const WebSocketCamera: FC<StompProps> = ({init, name, onHide, sound, isClose= false}) => {

    // const [imgByte, setImgByte] = useState<Uint8Array>(new Uint8Array())
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(actionCamera.clear({name: name} as ICameraPayload))
    })

    const close = useCallback(() => {
        if (onHide) {
            onHide()
        }
    }, [onHide])

    function SubscribingComponent () {
        const [imgByte, setImgByte] = useState<Uint8Array>(new Uint8Array())
        const [img64, setImg64] = useState<string>('')
        const [err, setErr] = useState<string>('')
        const user: IUser = useSelector((state: IRootState) => state.user.user);
        const [isFirstRecord, setIsFirstRecord] = useState<boolean>(false);

        const [mute, setMute] = useState<boolean>(true);

        // const queueRef = useRef<Array<Uint8Array>>([]);
        const queueRef = useRef<Array<string>>([]);

        // const [srcAudio, setSrc] = useState<Blob>({} as Blob);
        const [srcAudio, setSrcAudio] = useState<string>('');

        const audioRef = useRef<AudioPlayerRef>(null);

    //Subscribe to /topic/test, and use handler for all received messages
    //Note that all subscriptions made through the library are automatically removed when their owning component gets unmounted.
    //If the STOMP connection itself is lost they are however restored on reconnect.
    //You can also supply an array as the first parameter, which will subscribe to all destinations in the array
    useSubscription("/topic/cam/" + name + "/" + user.id, (message) => {
        setErr('')
        setImg64(message.body)
       setImgByte(message.binaryBody)
    });
    useSubscription("/topic/cam/error/" + user.id, (message) => {
        setErr(message.body)
        if (isClose) {
            dispatch(modal.showError(message.body))
        }
        close()
    });

    // if (sound) {
        useSubscription("/topic/audio/" + name + "/" + user.id, (message) => {
            // if (queueRef.current.length == 0 && isFirstRecord) {
            //     setSrcAudio(message.body);
            //     audioRef?.current?.play()
            // }
            // @ts-ignore
            if (queueRef.current.length == 0 && !isFirstRecord) {
                // setSrc(new Blob([message.binaryBody.buffer]))
                setSrcAudio(message.body)
                setIsFirstRecord(true)
            } else {
                // queueRef.current.push(message.binaryBody)
                queueRef.current.push(message.body)
                audioRef?.current?.play()
            }
        });
    // }


        const imgVideo = useCallback(() => {
            if (img64?.length > 0) {
                return <VideoImg src={`data:image/jpeg;base64,${img64}`}/>
            }
        }, [img64])

        const onMute = useCallback(() => {
            setMute(!mute)
        }, [mute])

        const audio = useMemo(() => {
            return <div>
                {/*style={{visibility: "collapse"}}*/}
                {/*style={{visibility: "collapse",  height: 0}}*/}
                {srcAudio?.length > 100 &&
                        <AudioPlayer ref={audioRef} style={{visibility: "collapse",  height: 0}}
                                                 // srcAudio={`${URL.createObjectURL(src2)}`}
                                                 src={`data:audio/mp3;base64,${srcAudio}`}
                                                 autoPlay
                                                 volume={mute ? 0 : 100}
                                                 onEnd={() => {
                    if (queueRef.current.length > 0) {
                        // @ts-ignore
                        // setSrc(new Blob([queueRef.current.shift()]));
                        setSrcAudio(queueRef.current.shift());
                    }
                }}
                />
                }

            </div>
        }, [srcAudio, mute])

        // return <div style={{visibility: "hidden"}}/>;
        // @ts-ignore
        return <VideoContainer>
            {err.length > 0  && <p>{err}</p>}
            {err.length == 0 && img64?.length == 0  && <Spinner variant={"primary"}/>}
            {/*{imgByte.byteLength > 0 && <img style={{objectFit: "scale-down"}} srcAudio={URL.createObjectURL(new Blob([imgByte]))}/>}*/}
            {/*{img64.length > 0 && <VideoImg srcAudio={`data:image/jpeg;base64,${img64}`}/>}*/}
            {imgVideo()}
            {sound && err.length == 0 && img64?.length > 0  && audio}
            {sound && srcAudio?.length > 100 && img64?.length > 0 && <Microfone onClick={onMute}>
                {mute && <VolumeMute size={35}></VolumeMute>}
                {!mute && <VolumeUp size={35}></VolumeUp>}
            </Microfone>}
            {isClose && <CloseButton onClick={() => close()}>
                {(err.length > 0 || img64?.length > 0) && <XSquareFill style={{backgroundColor: "white"}} size={25}></XSquareFill>}
            </CloseButton>}
        </VideoContainer>
}

    return (
        <div style={{display: "flex", justifyContent: "center"}}>
            <StompSessionProvider
                // onConnect={() => {
                //     fetchRefreshToken()
                // }}
                // connectHeaders={stompHeaders()}
                url={`${config.socketVideoUrl}`}
                //All options supported by @stomp/stompjs can be used here
            >
                {/*<SubscribingComponent/>*/}
                <SubscribeCamera name={name} sound={sound}/>
                <SendingMessages init={init}/>
            </StompSessionProvider>
            <CameraImage name={name} isClose={isClose} onHide={onHide} sound={sound}/>
            {sound && <CameraAudio name={name}/>}
        </div>
    )
}


export default memo(WebSocketCamera)

